module.exports = __webpack_public_path__ + "static/img/icon4.1153accc.png";